export default __webpack_public_path__ + "static/media/goldenCup.a8df37b8.svg";